import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { MedioPagoVentasSelect } from 'sharedComponents/select'

const FormaPagoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FORMA PAGO' htmlFor='select-formaPago' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='formaPago'>
          {({ field }) => (
            <MedioPagoVentasSelect
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-formaPago'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FormaPagoFormGroup)
